import { t } from "i18next";
import React from "react";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import phIrritating from "../../../assets/images/blurred2/imoji/irritating.png";
import phSwag from "../../../assets/images/blurred2/imoji/swag.png";
import phThumbsDown from "../../../assets/images/blurred2/imoji/thumb_down_1.png";
import phThumbsUp from "../../../assets/images/blurred2/imoji/thumb_up_1.png";
import ImageLoader from "../../../components/ImageLoader";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url, nextPageRoute } from "../../../utils/modules";

const content = {
  "content writing": {
    header: t("content_writing_knowledge.question"),
    navigate: "/aiTools",
    subHeader: t("content_writing_knowledge.upwork_info"),
    imagesToPreload: [
      "/imoji/shoking.png",
      "/imoji/thinking.png",
      "/imoji/swag.png",
    ],
  },
  "digital marketing": {
    header: t("digital_marketing_knowledge.question"),
    navigate: "/abilityrating",
    subHeader: t("digital_marketing_knowledge.upwork_info"),
    imagesToPreload: [],
  },
  "business ability": {
    header: (
      <Trans
        i18nKey={"promote_business_ability.question"}
        components={{ tag: <br /> }}
      />
    ),
    navigate: "/aipromotion",
    subHeader: t("promote_business_ability.upwork_info"),
    imagesToPreload: [
      "/imoji/shoking.png",
      "/imoji/thinking.png",
      "/imoji/swag.png",
    ],
  },
  readiness: {
    header: t("freelancing_readiness.question"),
    subHeader: null,
    navigate: "/platform",
    imagesToPreload: [
      "/jobs/freelancer.png",
      "/jobs/linkedIn.png",
      "/jobs/fivver.png",
      "/jobs/guru.png",
      "/jobs/toptal.png",
      "/jobs/upwork.png",
      "/jobs/designhill.png",
      "/jobs/flexjobs.png",
      "/jobs/behance.png",
      "/jobs/wwr.png",
    ],
  },
};

const data = [
  {
    src: addS3Url("/imoji/thumb_down_1.png"),
    placeHolderImage: phThumbsDown,
  },
  {
    src: addS3Url("/imoji/thumb_down_1.png"),
    placeHolderImage: phThumbsDown,
  },
  {
    src: addS3Url("/imoji/irritating.png"),
    placeHolderImage: phIrritating,
  },
  {
    src: addS3Url("/imoji/thumb_up_1.png"),
    placeHolderImage: phThumbsUp,
  },
  {
    src: addS3Url("/imoji/thumb_up_1.png"),
    placeHolderImage: phThumbsUp,
  },
];

const KnowledgeRating = ({ ratingType }) => {
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavigate = () => {
    nextPageRoute(
      navigate,
      "/" + params.gender + content[ratingType].navigate,
      dispatch,
      content[ratingType].imagesToPreload
    );
  };
  return (
    <MobileViewLayout>
      <div
        className={`rating-outer ${
          ratingType === "business ability" && "business-padding"
        } px-4`}
      >
        <h2
          className=" text-center rating-header"
          style={{ color: "black", fontWeight: "730" }}
        >
          {ratingType === "business ability" && (
            <>
              <ImageLoader
                src={addS3Url("/imoji/swag.png")}
                placeHolderImage={phSwag}
                className="buisness-img"
                alt="swag"
              />
              <br />
            </>
          )}
          {content[ratingType].header}
        </h2>
        {content[ratingType].subHeader && (
          <p
            className="rating-subheader text-center"
            style={{ color: "black", fontWeight: "600" }}
          >
            {content[ratingType].subHeader}
          </p>
        )}
        <div
          className="w-100 d-flex justify-content-between mt-4"
          style={{ gap: "5px" }}
        >
          {data.map((item, index) => (
            <button
              key={index}
              tabindex={index}
              className="ratings-card button-highlight"
              onClick={handleNavigate}
            >
              <ImageLoader
                className={
                  index % 2 === 0 ? "large-image-rating" : "small-image-rating"
                }
                alt="thumb_down"
                {...item}
              />
            </button>
          ))}
        </div>
        <div className="w-100 d-flex justify-content-between">
          <p className="secondary-ratings-text">
            {t("content_writing_knowledge.need_more_info")}
          </p>
          <p className="secondary-ratings-text">
            {t("content_writing_knowledge.know_everything")}
          </p>
        </div>
      </div>
    </MobileViewLayout>
  );
};

export default KnowledgeRating;
